import { h, Component, createRef } from 'preact';
import Logo from './Logo'


export default class Nav extends Component {
    
    constructor(props) {
        super(props);
        this.state = { 
            show: false
        }
        this.handleShow = this.handleShow.bind(this)
    }

    handleShow(){
        this.setState({show: !this.state.show})
    }
    
    render(){
        let { show } = this.state;

        return (
            <header class={(show ) ? "header show " : "header"}>

                <div className="header-icon">
                    <div class="logo">
                        <a href="/">
                            <Logo />
                        </a>
                    </div>
                    <div className="mobile-trigger">
                        <div onClick={() => this.handleShow()}>
                            {(!show) ? 
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                            : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>}
                        </div>
                    </div>    
                </div>

                <ul class="main-menu">
                    {/*<li class="menu-item"><a class="menu-link" href="/">Features</a></li>
                    <li class="menu-item"><a class="menu-link" href="/pricing">Pricing</a></li>*/}
                    <li class="menu-item"><a class="menu-link login-link" href="https://my.hovihealth.com" target="_blank">Log in</a></li>
                    <li class="menu-item sign-up"><a href="/request-demo">Request Demo</a></li>
                </ul>

                <div className="mobile-nav">
                    <div className="mobile-nav-container">
                        <div className="header-icon">
                            <div class="logo">
                                <Logo />
                            </div>
                            <div className="mobile-trigger">
                                <div onClick={() => this.handleShow()}>
                                    {(!show) ? 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>}
                                </div>
                            </div>    
                        </div>
                        <ul class="main-menu-mobile">
                            {/*<li class="menu-item"><a class="menu-link" href="/">Features</a></li>
                            <li class="menu-item"><a class="menu-link" href="/pricing">Pricing</a></li>*/}
                            <li class="menu-item"><a class="menu-link login-link" href="https://app.hovihealth.com" target="_blank">Log in</a></li>
                            <li class="menu-item sign-up"><a href="/request-demo">Request Demo</a></li>
                        </ul>
                    </div>
                </div>
            </header>
        );
    }   
};  



// WEBPACK FOOTER //
// ./components/Nav.js